var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vast-show-more",on:{"click":_vm.showMore}},[_c('div',{staticClass:"vast-show-more__line"}),_c('span',{staticClass:"vast-show-more__text"},[_vm._v(" "+_vm._s(_vm.isShowMore ? _vm.locale.hide : _vm.locale.showMore)+" ")]),_c('span',{class:[
      'vast-show-more__arrow',
      { open: _vm.isShowMore },
    ]},[_c('IconChevron',{attrs:{"width":"11px"}})],1),_c('div',{staticClass:"vast-show-more__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }